var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videoDuration)?_c('a-button',{staticClass:"button",attrs:{"ghost":""}},[_vm._v("\n    "+_vm._s(_vm.videoDuration)+"\n")]):_c('div',{staticClass:"button"},[_vm._v("\n    --\n")])}
var staticRenderFns = []

export { render, staticRenderFns }